import { waitForPageLoadAnalytics } from "../pageLoad";
import { fitAssistantPromise } from "./fitAssistant";
import { getCommons, getGlobalEvars, addMerchEVarToProducts } from "../common";
import getWindow from "../../utils/window";
import { setComponentPerformance } from "./componentPerformance";
import { setEvents, setLinkTrackEvents } from "../events";
import { backInStockPromise } from "./backInStock";
import { recommendedOutfitsPromise } from "./recommendedOutfits";
import { getProductFlags } from "../pageLoad/productFlags";

export const postPageLoad = async () => {
  await waitForPageLoadAnalytics;
  await fitAssistantPromise;
  await recommendedOutfitsPromise;
  await backInStockPromise;

  setComponentPerformance();
  setEvents({ events: ["event344"], trackingName: "postPageLoad" });

  const s = getWindow().s;
  const commons = getCommons();
  const productFlags = getProductFlags();

  if (productFlags.length) {
    s.eVar248 = productFlags;
    s.products = addMerchEVarToProducts(s.products, `eVar247=${productFlags}`);
  }

  const overrides = {
    linkTrackVars: commons.setLinkTrackVars([
      ...getGlobalEvars(),
      "prop36",
      "eVar50",
      "eVar163",
      "eVar164",
      "eVar165",
      "eVar166",
      "eVar167",
      "eVar168",
      "eVar169",
      "eVar170",
      "eVar248",
    ]),
    linkTrackEvents: setLinkTrackEvents({ trackingName: "postPageLoad" }),
  };

  s.tl(true, "o", "post page load", overrides);
};
